export enum CounterType {
    TASKS_TOTAL         = 'tasks-total',
    TASKS_ESTIMATES     = 'tasks-estimates',
    TASKS_STORY_POINTS  = 'tasks-story-points',
    TIME_REPORTS        = 'time-reports',
    EVENTS_TOTAL        = 'events-total',
    ASSIGNED_TASKS      = 'assigned-tasks',
}

export const CounterTypeLabel = {
    [CounterType.TASKS_TOTAL]       : 'Number of tasks',
    [CounterType.EVENTS_TOTAL]      : 'Number of events',
    [CounterType.TIME_REPORTS]      : 'Time reports',
    [CounterType.TASKS_ESTIMATES]   : 'Estimated time',
    [CounterType.TASKS_STORY_POINTS]: 'Story points',

    [CounterType.ASSIGNED_TASKS]    : 'Assigned tasks',
}

export enum GraphType {
    PIE             = 'pie',
    DONUT           = 'donut',
    BAR             = 'bar',
    BATTERY         = 'battery',
    LOLLIPOP        = 'lollipop',
    LINE            = 'line',

}

export const GraphTypeLabel = {
    [GraphType.PIE]         : 'Pie chart',
    [GraphType.DONUT]       : 'Donut chart',
    [GraphType.BAR]         : 'Bar chart',
    [GraphType.BATTERY]     : 'Battery chart',
    [GraphType.LOLLIPOP]    : 'Lollipop chart',
    [GraphType.LINE]        : 'Line chart',

}

export enum TickType {
    DAY     = 'day',
    WEEK    = 'week',
    MONTH   = 'month',
}

export const TickTypeLabel = {
    [TickType.DAY]      : 'Day',
    [TickType.WEEK]     : 'Week',
    [TickType.MONTH]    : 'Month',
}